export let BaseActionProductStatus = /*#__PURE__*/function (BaseActionProductStatus) {
  BaseActionProductStatus["Published"] = "published";
  BaseActionProductStatus["EnrollmentExpired"] = "expired";
  BaseActionProductStatus["Unpublished"] = "unpublished";
  return BaseActionProductStatus;
}({});